import React from 'react';
import EmptyCarHeader from './EmptyCarHeader';
import HazCarHeader from './HazCarHeader';
import NonHazCarHeader from './NonHazCarHeader';

const TrainCustomHeader = ({ data }) => {
  const { loaded, hazardousIndicator } = data;
  return !loaded ? (
    <EmptyCarHeader data={data} />
  ) : hazardousIndicator === 'Y' ? (
    <HazCarHeader data={data} />
  ) : (
    <NonHazCarHeader data={data} />
  );
};

export default TrainCustomHeader;
